import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { error } from 'console';
import { HouseholdService } from 'src/app/services/household.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-household',
  templateUrl: './household.component.html',
  styleUrls: ['./household.component.scss']
})
export class HouseholdComponent implements OnInit {
  /**
   * The Form to Filter
   */
  filterForm: UntypedFormGroup;
  /**
   * The Filteroptions
   */
  sortOptionsState = [
    { value: "1", viewValue: ">= 1 Erwachsene im Haushalt" },
    { value: "2", viewValue: ">= 2 Erwachsene im Haushalt" },
    { value: "3", viewValue: ">= 3 Erwachsene im Haushalt" },
    { value: "4", viewValue: ">= 4 Erwachsene im Haushalt" },
    { value: "5", viewValue: ">= 5 Erwachsene im Haushalt" },
    { value: "6", viewValue: ">= 6 Erwachsene im Haushalt" }
  ];
  /**
   * The List of Households that match the Filter
   */
  houseHoldList: Array<any> = [];
  /**
   * constructor
   * Init the Form
   * @param router 
   * @param route 
   * @param overlayService 
   * @param householdService 
   * @param fb 
   */
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private overlayService: OverlayService,
    public householdService: HouseholdService,
    private fb: UntypedFormBuilder) {
    this.filterForm = this.fb.group({
      searchTerm: [],
      filterByTypes: ['2']
    })
  }
/**
 * ngOnInit
 */
  ngOnInit() {
    this.route.queryParams.subscribe(prams=>{
      console.log(prams['count'])
      this.filterForm.patchValue({
        filterByTypes : prams['count']
      })
    })
  }
  /**
   * Reset the Filter
   */
  resetFilter() {
    this.filterForm.reset()
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          searchTerm: this.filterForm.value?.searchTerm,
          filterByTypes: this.filterForm.value?.filterByTypes
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        this.filterHouseHolds();
      })
  }
  /**
   * Filter the HouseHolds by the Filterfrom
   */
  filterHouseHolds() {
    this.householdService.getHouseHoldsWithAdultMembers(Number(this.filterForm.getRawValue().filterByTypes)).subscribe({
      next: (res: any) => {
        this.houseHoldList = res['content'];
      },
      error: error => {
        console.log(error)
      }
    })
  }
  /**
   * Set neverdeactivate to a User by its ID
   * @param houseHold 
   */
  neverdeactivateUserById(houseHold) {
    this.householdService.neverdeactivateUserById(houseHold.defaultCustomer.account.publicId, true).subscribe({
      next: res => {
        console.log(res)
      },
      error: error => {
        console.log(error)
      }
    })
  }
  /**
   * Ddeactivate a User by its ID
   * @param houseHold 
   */
  deactivateRequestUserById(houseHold) {
    this.householdService.deactivateUserById(houseHold.defaultCustomer.account.publicId).subscribe({
      next: res => {
        console.log(res)
      },
      error: error => {
        console.log(error)
      }
    })
  }
  /**
   * Reactivate a User by its ID
   * @param houseHold 
   */
  reactivateUserById(houseHold) {
    this.householdService.reactivateUserById(houseHold.defaultCustomer.account.publicId).subscribe({
      next: res => {
        console.log(res)
      },
      error: error => {
        console.log(error)
      }
    })
  }
  /**
   * Deactivate a User by its ID
   * @param houseHold 
   */
  deactivateUserById(houseHold) {
    this.householdService.deactivateUserById(houseHold.defaultCustomer.account.publicId).subscribe({
      next: res => {
        console.log(res)
      },
      error: error => {
        console.log(error)
      }
    })
  }

}
